import request from '../utils/request'
import setting from './apiSetting'

const myfunction = {
  GetData: function (url, data, method) {
    return request({
      url: setting.getFullUrl('', url),
      method: method || 'get',
      params: data,
    })
  },

  GetColumns: function (url, data) {
    return request({
      url: setting.getFullUrl('', url),
      method: 'get',
      params: data,
    })
  },

  GetListData: function (url, params, data, method) {
    return request({
      url: setting.getFullUrl('', url),
      method: method ?? 'get',
      params: params,
      data: data,
    })
  },

  GetModelData: function (url, data) {
    return request({
      url: setting.getFullUrl('', url),
      method: 'get',
      params: data,
    })
  },

  AddEditData: function (url, params, data) {
    return request({
      url: setting.getFullUrl('', url),
      method: 'post',
      params: params,
      data: data,
    })
  },

  RemoveData: function (url, params, data) {
    return request({
      url: setting.getFullUrl('', url),
      method: 'post',
      params: params,
      data: data,
    })
  },

  EditData: function (url, params, data) {
    return request({
      url: setting.getFullUrl('', url),
      method: 'put',
      params: params,
      data: data,
    })
  },
}

export default myfunction
